import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { chartActions } from "../../../store/chart-slice";
import {
  CONTACT_EVENT_TYPES,
  CONTACT_TYPE_LABELS,
} from "../../../util/floorContacts";

/**
 * Global + per-event-type toggles for floor contact markers.
 * Only rendered when the parent has confirmed contacts are available.
 */
function ContactMarkerToggles() {
  const dispatch = useDispatch();
  const globalVisible = useSelector((state) => state.chart.contactGlobalVisible);
  const typeVisible = useSelector((state) => state.chart.contactTypeVisible);
  const sourceVisible = useSelector((state) => state.chart.contactSourceVisible);

  return (
    <div
      className="contact-marker-toggles no-print"
      data-testid="contact-marker-toggles"
    >
      <label className="contact-marker-toggles__global">
        <input
          type="checkbox"
          checked={!!globalVisible}
          onChange={(e) =>
            dispatch(chartActions.setContactGlobalVisible(e.target.checked))
          }
          data-testid="contact-markers-global"
        />
        <span>Show contact markers</span>
      </label>

      {globalVisible ? (
        <div
          className="contact-marker-toggles__sources"
          data-testid="contact-marker-source-row"
        >
          <label className="contact-marker-toggles__type">
            <input
              type="checkbox"
              checked={sourceVisible?.pipeline !== false}
              onChange={(e) =>
                dispatch(
                  chartActions.setContactSourceVisible({
                    source: 'pipeline',
                    visible: e.target.checked,
                  })
                )
              }
              data-testid="contact-source-pipeline"
            />
            <span>Pipeline</span>
          </label>
          <label className="contact-marker-toggles__type">
            <input
              type="checkbox"
              checked={sourceVisible?.user !== false}
              onChange={(e) =>
                dispatch(
                  chartActions.setContactSourceVisible({
                    source: 'user',
                    visible: e.target.checked,
                  })
                )
              }
              data-testid="contact-source-user"
            />
            <span>Manual</span>
          </label>
        </div>
      ) : null}

      {globalVisible ? (
        <div
          className="contact-marker-toggles__types"
          data-testid="contact-marker-type-row"
        >
          {CONTACT_EVENT_TYPES.map((typeKey) => (
            <label key={typeKey} className="contact-marker-toggles__type">
              <input
                type="checkbox"
                checked={typeVisible?.[typeKey] !== false}
                onChange={(e) =>
                  dispatch(
                    chartActions.setContactTypeVisible({
                      typeKey,
                      visible: e.target.checked,
                    })
                  )
                }
                data-testid={`contact-type-${typeKey}`}
              />
              <span>{CONTACT_TYPE_LABELS[typeKey] || typeKey}</span>
            </label>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default ContactMarkerToggles;
